export { default as BundleProductCardDS } from './bundle-product-card-ds'
